// import mockedData from '@/utils/mocked-data/user/profile'

import { fetchFromApi } from '@/utils/store/concerns/loadable/actions'
// import { fetchFromApiMocked } from '@/utils/store/concerns/mockable/actions'

export const fetch = function({ commit }, { userId }) {
  fetchFromApi(this, commit, `/users/${userId}/fidmarques_wallet`)
}
